import { AnalyticsConnector } from '@amplitude/analytics-connector';
export var getAnalyticsConnector = function () {
    return AnalyticsConnector.getInstance('$default_instance');
};
export var setConnectorUserId = function (userId) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getAnalyticsConnector().identityStore.editIdentity().setUserId(userId).commit();
};
export var setConnectorDeviceId = function (deviceId) {
    getAnalyticsConnector().identityStore.editIdentity().setDeviceId(deviceId).commit();
};
//# sourceMappingURL=analytics-connector.js.map